export const initSmartlook = (smartlookKey?: string): void => {
	if(!smartlookKey) {
		return;
	}

	// Inject as a <script> element, as this does not bundle cleanly.
	const script = document.createElement("script");
	script.innerText = `window.smartlook||(function(d) { var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0]; var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript'; c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c); })(document); smartlook('init', '${smartlookKey}', { region: 'eu', cookies: false });`;
	document.head.append(script);
};